import { InvoiceBase } from './billing.types';

export const getFinalizeTooltipMessage = (
  invoice:
    | Pick<
        InvoiceBase,
        | 'hasUnconfirmedSessions'
        | 'previousInvoiceSubmitted'
        | 'noSessions'
        | 'noSignature'
        | 'noSessionsPlan'
        | 'noMinActivities'
        | 'noContactWithParent'
        | 'missingRelatedServicesConfirmation'
      >
    | undefined,
) => {
  if (!invoice) return undefined;

  const {
    hasUnconfirmedSessions,
    previousInvoiceSubmitted,
    noSessions,
    noSignature,
    noSessionsPlan,
    noMinActivities,
    noContactWithParent,
    missingRelatedServicesConfirmation,
  } = invoice;

  return hasUnconfirmedSessions
    ? 'Billing cannot be finalized prior to confirming scheduled sessions.'
    : previousInvoiceSubmitted === false
    ? 'Billing must first be finalized for previous months.'
    : noSessions
    ? 'There is no sessions.'
    : noSessionsPlan
    ? 'There is no session plan for the month the invoice covers.'
    : noMinActivities
    ? 'Invoices cannot be finalized before logging student services.'
    : noContactWithParent
    ? 'Invoices cannot be finalized before logging parent conference.'
    : missingRelatedServicesConfirmation
    ? 'Invoices cannot be finalized before logging coordination activities.'
    : noSignature
    ? 'Invoices cannot be finalized prior to signature approval.'
    : undefined;
};
